/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const homepageApi = platform.learningPanel.HomepageAPIs;

export const getHomepageCompletionData = 'homepage-completion-data';

export const useGetCompletionData = (userUuid?: string, enableQuery?: boolean) => {
    return useQuery([getHomepageCompletionData, userUuid], () => homepageApi.getCompletionData(), {
        enabled: Boolean(userUuid) && enableQuery
    });
};
